<template>
  <div>
    <formTitle title="報讀科目 Subjects Applied"></formTitle>
    <p>
      申請人需要修讀三個核心科目(Core)及六個由組別一(Group 1)至組別六(Group
      6)選取的科目，其中包括高級程度(Higher Level)與標準程度(Standard
      Level)各三科。申請人需在組別一、組別二及組別五各選修一科，並在組別三及組別四至少選修一科；如不選修組別六的科目，申請人需在組別三或組別四中多選一科。
    </p>
    <p>
      The applicant must take all three Core subjects and six subjects selected
      from Group 1 to Group 6, three of which are Higher Level and three of
      which are Standard Level. one subject from Group 1, Group 2 and Group 5
      and at least one subject from Group 3 AND Group 4. If Group 6 subject is
      not selected, the applicant should select an additional subject from Group
      3 OR Group 4.
    </p>
    <el-form
      ref="subjectsApplied"
      label-position="top"
      :model="subjectsApplied"
      label-width="80px"
    >
      <div class="subjectsApplied-box">
        <div class="plain-button-title">Core</div>
        <div class="subjectsApplied-content">
          <el-form-item>
            <el-checkbox-group v-model="subjectsApplied.core">
              <template v-for="(item, index) in checkboxGroup">
                <el-row
                  v-if="index % 2 === 0"
                  :key="index"
                  :gutter="20"
                  type="flex"
                  align=""
                >
                  <el-col v-for="(v, k) in checkboxGroup.slice(index, index + 2)"
                      :key="k" :span="12">
                    <el-checkbox
                      :disabled="true"
                      
                      :label="v"
                      name="type"
                    ></el-checkbox
                  ></el-col>
                </el-row>
              </template>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
      <!-- <div class="subjectsApplied-box">
        <div class="plain-button-title">Electives</div>
        <p>Please choose 3 or 4 out of the following subjects:</p>
        <div class="subjectsApplied-content">
          <el-form-item>
            <el-checkbox-group v-model="subjectsApplied.eletives">
              <el-checkbox
                :disabled="isView"
                v-for="(item, index) in checkboxGroupEletives"
                :key="index"
                :label="item"
                name="type"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div> -->
      <div class="subjectsApplied-box">
        <div class="plain-button-title">Other Subjects</div>
        <p>
          Please choose at least one subject from each group, except for Group
          6.
        </p>
        <div class="subjectsApplied-content">
          <el-row type="flex" align="middle">
            <el-col :span="12"> </el-col>
            <el-col :span="6" style="text-align: center" class="subjects-title">
              Standard Level
            </el-col>
            <el-col :span="6" style="text-align: center" class="subjects-title"> Higher Level </el-col>
          </el-row>
          <div
            class="group-list"
            v-for="(items, indexs) in groupTypes"
            :key="indexs"
          >
            <el-row
              type="flex"
              v-for="(item, index) in setGroup(items)"
              :key="index"
              align="middle"
              class="row-middle"
            >
              <el-col :span="12">
                <div class="group-list-title subjects-title" v-if="index == 0">
                  {{ items.label }}
                </div>
                {{ item.subject }}
              </el-col>
              <el-col :span="6" style="text-align: center">
                <el-checkbox
                  :disabled="isView || (item.groupType==1 || item.groupType==0)"
                  v-model="item.isSelectedStandardLevel"
                ></el-checkbox
              ></el-col>
              <el-col :span="6" style="text-align: center"
                ><el-checkbox
                  :disabled="isView || (item.groupType==0 || item.groupType==1)"
                  v-model="item.isSelectedHigherLevel"
                ></el-checkbox>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-form-item
        v-if="!isView && !adminEdit"
        class="from-button-group"
        label=""
        style="text-align: center"
      >
        <el-button type="success" @click="onBack"> 返回 Back </el-button>
        <el-button type="primary" @click="onSave"> 儲存 Save </el-button>
        <el-button type="primary" @click="onSaveAndSubmit">
          儲存及遞交 Save and Submit
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import formTitle from "@/components/formTitle";
export default {
  components: {
    formTitle,
  },
  props: {
    subjectsApplied: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
    adminEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupOne() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 0;
      });
    },
    groupTwo() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 1;
      });
    },
    groupThree() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 2;
      });
    },
    groupFour() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 3;
      });
    },
    groupFive() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 4;
      });
    },
    groupSix() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 5;
      });
    },
  },
  data() {
    return {
      groupTypes: [
        {
          label: "Group1",
          value: 0,
        },
        {
          label: "Group2",
          value: 1,
        },
        {
          label: "Group3",
          value: 2,
        },
        {
          label: "Group4",
          value: 3,
        },
        {
          label: "Group5",
          value: 4,
        },
        {
          label: "Group6",
          value: 5,
        },
      ],
      checkboxGroup: [
        "Creativity, Action and Service",
        "Extended Essay",
        "Theory of Knowledge",
      ],
     
      checkboxGroupEletives: [
        "Biology",
        "BAFS (Accounting)",
        "BAFS (Business Management)",
        "Chemistry",
        "Chinese History",
        "Chinese Literature",
        "Economics",
        "Geography",
        "History",
        "Information & Communication Technology",
        "Literature in English",
        "Mathematics Extended Part (Module 1)",
        "Mathematics Extended Part (Module 2)",
        "Music",
        "Physics",
        "Visual Arts",
      ],
      applicantLanguages: [
        {
          label: "英語 English",
          value: 0,
        },
        {
          label: "普通話 Putonghua",
          value: 1,
        },
        {
          label: "廣東話 Cantonese",
          value: 2,
        },
      ],
    };
  },
  created(){
    this.initial()
  },
  methods: {
    initial(){
      this.subjectsApplied.core = this.checkboxGroup
    },
    setGroup(items) {
      let newGroup = [];
      switch (items.value) {
        case 0:
          newGroup = this.groupOne;
          break;
        case 1:
          newGroup = this.groupTwo;
          break;
        case 2:
          newGroup = this.groupThree;
          break;
        case 3:
          newGroup = this.groupFour;
          break;
        case 4:
          newGroup = this.groupFive;
          break;
        case 5:
          newGroup = this.groupSix;
          break;
      }
      return newGroup;
    },
    setLabel(index) {
      let newLabel = "";
      switch (index) {
        case 0:
          newLabel = "第一語言 First language";
          break;
        case 1:
          newLabel = "第二語言 Second language ";
          break;
        case 2:
          newLabel = "家中主要使用語言 Main language used at home";
          break;
      }
      return newLabel;
    },
    onBack() {
      this.$emit("onSubjectsAppliedBack");
    },
    onSave() {
      this.$emit("onSubjectsAppliedSave");
    },
    onSaveAndSubmit() {
      this.$emit("onSubjectsAppliedSaveAndSubmit");
    },
  },
};
</script>

<style lang="scss" scoped>
.subjectsApplied-box {
  margin: 20px 0;
}
.subjectsApplied-content {
  padding: 2.5rem;
  //蓝色边框
  border: 1px solid #0094ff;
  border-radius: 5px;
}
.el-button--primary {
  width: auto;
}
.row-middle {
  padding: 0.625rem 0;
}
.group-list {
  padding: 0.625rem 0;
  border-bottom: 1px solid #ebeef5;
}
.group-list-title {
  margin-bottom: 0.625rem;
}
.subjects-title{
  font-weight: bold;
  font-size: 1.25rem;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .subjectsApplied-content {
    padding: 1.875rem;
  }
   .from-button-group .el-button{
    margin-bottom: 0.625rem;
  }
  .from-button-group .el-button:last-child{
    margin-left: 0;
  }
  .subjects-title{
     font-size: 0.875rem;
  }
  ::v-deep{
   .el-checkbox__label{
     white-space:pre-wrap;
      word-wrap:break-word;
      word-break:keep-all;
      word-wrap:break-word;
      }
  }

}
</style>